import { useEffect, useState } from 'react';

// Hook simples de media query - usado pra alternar comportamento (não só
// estilo) conforme o tamanho de tela, algo que puro CSS não resolve (ex.:
// desligar a legenda interna do Chart.js e trocar por uma em HTML só em
// telas pequenas).
const useMediaQuery = (query) => {
    const [matches, setMatches] = useState(
        () => typeof window !== 'undefined' && window.matchMedia(query).matches
    );

    useEffect(() => {
        const mql = window.matchMedia(query);
        const handleChange = (e) => setMatches(e.matches);

        setMatches(mql.matches);

        if (mql.addEventListener) {
            mql.addEventListener('change', handleChange);
            return () => mql.removeEventListener('change', handleChange);
        }

        // Fallback pra navegadores antigos (Safari < 14)
        mql.addListener(handleChange);
        return () => mql.removeListener(handleChange);
    }, [query]);

    return matches;
};

export default useMediaQuery;
